// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box; }

.heading-btn-container {
  margin-bottom: -32px; }
  .heading-btn-container .heading {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    margin-top: -20px; }
    .heading-btn-container .heading span {
      font-size: 16px;
      font-weight: 600;
      color: #323232; }
    .heading-btn-container .heading button span {
      font-size: 13px;
      font-weight: 600;
      text-align: center;
      color: white; }

.table-btn-container {
  display: flex;
  flex-direction: column; }
  .table-btn-container .week {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
    height: 44px;
    font-weight: 600;
    font-size: 16px;
    color: #637f92;
    background: #f8fafb;
    border: 1px solid #e1e7ec;
    border-bottom: none;
    border-radius: 8px 8px 0px 0px; }
    .table-btn-container .week .deleteBtn {
      position: relative;
      top: 8px;
      right: 15px; }
  .table-btn-container .abstractTable h2 {
    margin-bottom: 0 !important; }

.add-btn .ant-btn {
  background: #586f80;
  border-radius: 2px;
  height: 32px;
  width: 95px;
  color: white;
  font-weight: 600;
  text-align: center;
  transition: all 0.5s linear;
  border: none; }
  .add-btn .ant-btn:hover, .add-btn .ant-btn:focus {
    color: white;
    background: #586f80;
    border: none; }

.btn1 .btn-container {
  margin: 0;
  display: flex;
  justify-content: flex-end; }
  .btn1 .btn-container button {
    display: flex;
    align-items: center; }

.btn1 .ant-btn {
  background: none;
  margin-top: 5px;
  border-radius: 2px;
  padding: 8px 12px;
  color: #586f80;
  font-weight: 600;
  text-align: right;
  transition: all 0.5s linear;
  border: none;
  box-shadow: none; }
  .btn1 .ant-btn:hover, .btn1 .ant-btn:focus {
    color: #586f80;
    background: none;
    border: none; }

.input-table-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px; }
  .input-table-header .heading {
    margin-bottom: 4px;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    color: #323232; }
  .input-table-header .paragraph {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: -0.15px;
    color: #767676; }

[ant-click-animating-without-extra-node]:after {
  animation: none !important; }
`, "",{"version":3,"sources":["webpack://./src/components/TableInput/style.scss"],"names":[],"mappings":"AAAA;EACI,UAAU;EACV,SAAS;EACT,sBAAsB,EAAA;;AAG1B;EACI,oBAAoB,EAAA;EADxB;IAIQ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB,EAAA;IARzB;MAWY,eAAe;MACf,gBAAgB;MAChB,cAAc,EAAA;IAb1B;MAkBgB,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,YAAY,EAAA;;AAM5B;EACI,aAAa;EACb,sBAAsB,EAAA;EAF1B;IAKQ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,8BAA8B,EAAA;IAhBtC;MAmBY,kBAAkB;MAClB,QAAQ;MACR,WAAW,EAAA;EArBvB;IA2BY,2BAA2B,EAAA;;AAKvC;EAEQ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY,EAAA;EAVpB;IAcY,YAAY;IACZ,mBAAmB;IACnB,YAAY,EAAA;;AAKxB;EAEQ,SAAS;EACT,aAAa;EACb,yBAAyB,EAAA;EAJjC;IAOY,aAAa;IACb,mBAAmB,EAAA;;AAR/B;EAaQ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB,EAAA;EAtBxB;IA0BY,cAAc;IACd,gBAAgB;IAChB,YAAY,EAAA;;AAMxB;EACI,aAAa;EACb,8BAA8B;EAC9B,mBAAmB,EAAA;EAHvB;IAMQ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc,EAAA;EAXtB;IAeQ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,cAAc,EAAA;;AApCtB;EA6CI,0BAA0B,EAAA","sourcesContent":["* {\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n}\n\n.heading-btn-container {\n    margin-bottom: -32px;\n\n    .heading {\n        display: flex;\n        justify-content: space-between;\n        flex-direction: row;\n        align-items: center;\n        margin-top: -20px;\n\n        span {\n            font-size: 16px;\n            font-weight: 600;\n            color: #323232;\n        }\n\n        button {\n            span {\n                font-size: 13px;\n                font-weight: 600;\n                text-align: center;\n                color: white;\n            }\n        }\n    }\n}\n\n.table-btn-container {\n    display: flex;\n    flex-direction: column;\n\n    .week {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 14px 18px;\n        height: 44px;\n        font-weight: 600;\n        font-size: 16px;\n        color: #637f92;\n        background: #f8fafb;\n        border: 1px solid #e1e7ec;\n        border-bottom: none;\n        border-radius: 8px 8px 0px 0px;\n\n        .deleteBtn {\n            position: relative;\n            top: 8px;\n            right: 15px;\n        }\n    }\n\n    .abstractTable {\n        h2 {\n            margin-bottom: 0 !important;\n        }\n    }\n}\n\n.add-btn {\n    .ant-btn {\n        background: #586f80;\n        border-radius: 2px;\n        height: 32px;\n        width: 95px;\n        color: white;\n        font-weight: 600;\n        text-align: center;\n        transition: all 0.5s linear;\n        border: none;\n\n        &:hover,\n        &:focus {\n            color: white;\n            background: #586f80;\n            border: none;\n        }\n    }\n}\n\n.btn1 {\n    .btn-container {\n        margin: 0;\n        display: flex;\n        justify-content: flex-end;\n\n        button {\n            display: flex;\n            align-items: center;\n        }\n    }\n\n    .ant-btn {\n        background: none;\n        margin-top: 5px;\n        border-radius: 2px;\n        padding: 8px 12px;\n        color: #586f80;\n        font-weight: 600;\n        text-align: right;\n        transition: all 0.5s linear;\n        border: none;\n        box-shadow: none;\n\n        &:hover,\n        &:focus {\n            color: #586f80;\n            background: none;\n            border: none;\n        }\n    }\n}\n\n// input-table-header\n.input-table-header {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n\n    .heading {\n        margin-bottom: 4px;\n        font-style: normal;\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 16px;\n        color: #323232;\n    }\n\n    .paragraph {\n        font-style: normal;\n        font-weight: normal;\n        font-size: 14px;\n        line-height: 14px;\n        letter-spacing: -0.15px;\n        color: #767676;\n    }\n}\n\n[ant-click-animating-without-extra-node]:after {\n    -webkit-animation: none !important;\n    -moz-animation: none !important;\n    -o-animation: none !important;\n    -ms-animation: none !important;\n    animation: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
